<script lang="ts">
  import { navigate } from "$lib/router.svelte";
  let { to, class: cls = "", onNav, children } = $props<{
    to: string;
    class?: string;
    onNav?: () => void;
    children?: any;
  }>();
</script>

<a href={to} class={cls} onclick={(e) => { e.preventDefault(); navigate(to); onNav?.(); }}>
  {@render children?.()}
</a>
